<template>
    <div class="google_ad_banner_wrapper" v-if="has_banner_data" v-html="bannerMkp" style="width: 100%;"></div>
</template>

<script>

export default {
    props: ["size", "autoDetect", "ad_id"],
    async serverPrefetch () {
        return this.loadBanner();
    },
    mounted() {
        if(!this.has_banner_data) {
            this.loadBanner();
        }
    },
    computed: {
        has_banner_data() {
            return !!(this.banner_details && this.banner_details.wrapper);
        },
        banner_details() {
            return this.$store.state.gamezyAds[this.size];
        },
        bannerMkp() {
            if(this.banner_details.wrapper) {
                return this.banner_details.wrapper.replace(/{fg-ad-id}/g, this.ad_id);
            } else {
                return "";
            }
        },
        is_mobile_view() {
            return this.$store.state.ismobile;
        }
    },
    methods: {
        loadBanner() {
            if(this.autoDetect && 
                ((!this.is_mobile_view && this.banner_details.resolution == "mob") ||
                (this.is_mobile_view && this.banner_details.resolution == "web"))
            ) {
                return this.$store.dispatch('fetchGamezyBanner', {size: null, ad_id: this.ad_id});
            } else {
                return this.$store.dispatch('fetchGamezyBanner', {size: this.size, ad_id: this.ad_id});
            }
        }
    }
}
</script>